import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Flex } from 'components/Layout'
import StarRate from 'components/StarRate'
import { Text } from 'components/Typography'
import { FONT_SIZE, SPACE } from 'Theme'

const RatingWrapper = styled(Flex)`
  line-height: initial;
`

export const AverageRating = ({ averageRating, count }) => (
  <RatingWrapper alignItems="flex-end">
    <StarRate value={averageRating} isDisabled />
    <Text ml={SPACE.PX_15} fontSize={FONT_SIZE.PX_16}>
      {averageRating.toFixed(2)} ({count} {count === 1 ? 'Review' : 'Reviews'})
    </Text>
  </RatingWrapper>
)

AverageRating.propTypes = {
  averageRating: PropTypes.number,
  count: PropTypes.number,
}
